import React from 'react';
import SiteFooter from '../components/common/SiteFooter';
import './Legal.css';

const Terms: React.FC = () => {
  return (
    <div className="legal-page">
      <main className="legal-card" aria-labelledby="terms-title">
        <header className="legal-card__header" data-tour="legal-header">
          <h1 id="terms-title">Terms of Service</h1>
          <p>Last updated: March 24, 2026</p>
        </header>

        <div className="legal-card__content" data-tour="legal-content">
          <section>
            <h2>Use of Platform</h2>
            <p>
              iKompete is provided for authorized users to participate in academic and research-oriented
              competitions. You agree to use the service in accordance with University policy and applicable law.
            </p>
          </section>

          <section>
            <h2>Account Responsibilities</h2>
            <ul>
              <li>You are responsible for activity performed under your account.</li>
              <li>Do not share credentials or attempt unauthorized access.</li>
              <li>Provide accurate profile and submission information.</li>
            </ul>
          </section>

          <section>
            <h2>Competition Conduct</h2>
            <ul>
              <li>Follow competition rules, deadlines, and eligibility requirements.</li>
              <li>Do not submit malicious, infringing, or prohibited content.</li>
              <li>Do not attempt to manipulate judging, scoring, or access controls.</li>
            </ul>
          </section>

          <section>
            <h2>Content and Availability</h2>
            <p>
              The platform may be updated, restricted, or interrupted for maintenance and operational reasons.
              DSRS may remove content or restrict access to preserve security and integrity.
            </p>
          </section>

          <section>
            <h2>Limitation</h2>
            <p>
              iKompete is provided on an as-available basis for educational and research use.
              No guarantee is made regarding uninterrupted availability or specific outcomes.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              For support or terms-related questions, email <a href="mailto:dsrs@business.illinois.edu">dsrs@business.illinois.edu</a>.
            </p>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default Terms;

